import React from 'react';
import { HowToPlayModal } from '../../components/HowToPlayModal/HowToPlayModal';

export function HowToPlay({ onClose }) {
  return (
    <HowToPlayModal title="How to Play" titleId="full-crossword-how-title" onClose={onClose}>
      <p className="how-to-play-intro">
        Fill the <strong>5×5 grid</strong> so each row and each column forms a valid five-letter word.
      </p>
      <p className="how-to-play-intro">
        Time runs after your first letter; score is higher when you finish faster.
      </p>
      <p className="how-to-play-intro">Sign in to save your best score and daily streak.</p>
    </HowToPlayModal>
  );
}
